import { Badge, Loading } from '@ui-components/neo.tax';

import { DOCUMENT_STATUS_LABELS } from '@neo.tax/shared/constants';
import { DocumentStatus } from '@neo.tax/shared/graphql';

import { LoadingSection } from './document-status-badge.styled';

interface DocumentStatusBadgeProps {
  status: DocumentStatus | null;
}

export const DocumentStatusBadge = ({ status }: DocumentStatusBadgeProps): React.ReactElement => {
  switch (status) {
    case DocumentStatus.ReadyForDownload: {
      return (
        <Badge colorVariant="green" dot={false}>
          {DOCUMENT_STATUS_LABELS[DocumentStatus.ReadyForDownload]}
        </Badge>
      );
    }
    case DocumentStatus.HumanReview: {
      return (
        <Badge colorVariant="yellow" dot={false}>
          {DOCUMENT_STATUS_LABELS[DocumentStatus.HumanReview]}
        </Badge>
      );
    }
    case DocumentStatus.MissingInformation: {
      return (
        <Badge colorVariant="red" dot={false}>
          {DOCUMENT_STATUS_LABELS[DocumentStatus.MissingInformation]}
        </Badge>
      );
    }
    case DocumentStatus.ReadyToSubmit: {
      return (
        <Badge colorVariant="blue" dot={false}>
          {DOCUMENT_STATUS_LABELS[DocumentStatus.ReadyToSubmit]}
        </Badge>
      );
    }
    default:
      return (
        <LoadingSection>
          <Loading height={40} />
        </LoadingSection>
      );
  }
};
